var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbexLogoLgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1496.84 309.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #2bc3ef;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.26,138.13v-.58c13.91-8.93,20.87-21.98,20.87-39.16,0-12.57-3.34-23.13-10.02-31.67-10.2-13.05-28.47-19.58-54.81-19.58h-38.99v42.62h28.98c4.36,0,7.7.24,10.02.72,9.27,1.25,13.91,6.48,13.91,15.69,0,13.25-5.47,19.87-16.42,19.87h-36.49v40.31h37.46c14.28,0,21.43,5.66,21.43,16.99,0,2.59-.47,5.76-1.39,9.5-2.97,7.58-8.63,11.37-16.97,11.37h-40.53v15.69s3.96,7.68,13.63,15.48c12.09,9.76,20.37,13.32,20.37,13.32h19.46c6.49,0,13.12-1.15,19.89-3.46,25.97-10.65,38.96-29.27,38.96-55.86v-3.46c0-23.52-9.79-39.45-29.36-47.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.5,258.09s-33.24,1.03-57.12-5.11c-19.89-5.11-33-17.62-36.41-28.98-2.56-8.52-2.27-30.69-2.27-30.69V47.25h49.48v146.06s-.13,15.66,2.84,27.56c6.54,26.14,43.48,37.23,43.48,37.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.46,183.84s-4.93,21.59-15.08,35.7c-13.84,19.24-31.97,29.06-31.97,29.06,0,0,8.58,1.11,21.59-3.18,12.18-4.02,16.61-9.27,16.61-9.27,0,0,3.7-8.93,6.92-23.53,3.6-16.33,1.94-28.78,1.94-28.78h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.4,173.61v-95.72h40.21v95.63c0,12.5,10.73,20.8,22.11,20.8s22.3-8.49,22.3-20.8v-95.63h40.21v95.72c0,34.52-27.99,58.87-62.41,58.87s-62.41-24.35-62.41-58.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M599.36,182.38c0,23.79-19.97,45.9-50.1,45.9h-64.18V77.89h49.44c27.24,0,47.21,18.38,47.21,39.09,0,15.49-10.26,26.59-16.42,26.59,16.05,0,34.05,16.14,34.05,38.81h0ZM533.31,112.6h-9.79v23.6h9.52c8.68,0,15.21-4.29,15.21-12.03,0-7.28-6.34-11.57-14.93-11.57h-.01ZM561.11,177.62c0-8.77-6.35-14.09-17.63-14.09l-19.96-.09v28.55h19.68c9.14,0,17.91-4.48,17.91-14.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M654.84,115.02v20.99h47.77v33.31h-47.77v21.55h58.03v37.41h-97.49V77.89h97.49v37.13h-58.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M770.68,150.2l-45.15-72.3h45.71l23.04,39.74,22.95-39.74h45.71l-45.34,72.21,47.86,78.18h-45.99l-25.28-44.41-25.19,44.41h-45.99l47.67-78.09h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1024.43,74.98v153.65h-23.6v-83.4l-49.91,80.88h-.19l-50.01-80.98v83.5h-23.6V74.98h1.77l71.93,109.34,71.84-109.34h1.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1061.66,101.48v38.53h56.91v23.51h-56.91v41.61h65.96v23.51h-89.56V78.25h89.56v23.23h-65.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1257.21,153.63c0,46.18-29.76,75.01-77.53,75.01h-42.82V78.25h42.82c47.77-.09,77.53,28.83,77.53,75.38ZM1233.33,153.53c0-31.91-20.71-51.87-53.74-51.87h-19.22v103.46h19.5c32.84,0,53.46-19.87,53.46-51.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1263.56,78.25h23.6v150.39h-23.6V78.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1395.49,205.78h-71.18l-10.26,22.86h-25.56l70.72-153.47h1.4l70.72,153.47h-25.56l-10.26-22.86h-.02ZM1386.34,185.53l-26.4-58.77-26.5,58.77h52.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbexLogoLgDark);
export default __webpack_public_path__ + "static/media/ubex-logo-lg-dark.29caf76c093b2dde9a2917b6d3b83e1d.svg";
export { ForwardRef as ReactComponent };